export default "__VITE_ASSET__CWNk4PD2__"